import React from "react";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import "./App.css";
import Header from "./components/Header";
import WhatsAppButton from "./components/WhatsAppButton";
import OrganizationSchema from "./components/OrganizationSchema";
import { Toaster } from "./components/ui/sonner";
import { contactInfo } from "./data/mock";

// Pages
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import ServiceDetailPage from "./pages/ServiceDetailPage";
import EngineeringPage from "./pages/EngineeringPage";
import IndustrialPage from "./pages/IndustrialPage";
import PortfolioPage from "./pages/PortfolioPage";
import ContactPage from "./pages/ContactPage";

function AppContent() {
  const navigate = useNavigate();

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/contact');
    }
  };

  const handleWhatsApp = () => {
    window.open(`https://wa.me/${contactInfo.whatsapp}`, '_blank');
  };

  return (
    <div className="App">
      <OrganizationSchema />
      <Header onGetQuote={scrollToContact} />
      <Routes>
        <Route path="/" element={<HomePage scrollToContact={scrollToContact} handleWhatsApp={handleWhatsApp} />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/services/:slug" element={<ServiceDetailPage />} />
        <Route path="/engineering" element={<EngineeringPage />} />
        <Route path="/industrial" element={<IndustrialPage />} />
        <Route path="/portfolio" element={<PortfolioPage />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
      <WhatsAppButton />
      <Toaster />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
